import { Component } from '@angular/core';

@Component({
  selector: 'dl-sidebar-container',
  templateUrl: './sidebar-container.component.html',
  styleUrls: ['./sidebar-container.component.css'],
})
export class DlSidebarContainerComponent {}
